module.exports = "/images/az.svg?1f6cfe6f214b61a4cee52c2a75308c1a";